module.exports = __webpack_public_path__ + "static/img/grafana_logo.482022f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/grafana_logo.png
// module id = vUzX
// module chunks = 2